import * as React from 'react';
import PropTypes from 'prop-types';
import {Confirm, Icon, Label} from "semantic-ui-react";
import {translate} from "react-i18next";
import {Subbar, SubItem, Title, SearchFilter, PageHeader, Sortable} from "ah-tools";
import {Divider, IconMenu, List, ListItem, MenuItem, SelectField, Subheader} from "material-ui";
import {LOC_HOUSE_LIST_OPTIONS} from "../actions";
import Placeholder from "./Placeholder";
import ExtensionMenu from "../extensions/ExtensionMenu";
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import UndeleteIcon from 'material-ui/svg-icons/av/replay';
import ActivateIcon from 'material-ui/svg-icons/av/play-arrow';
import DeactivateIcon from 'material-ui/svg-icons/av/pause';
import {COLOR_POSITIVE, COLOR_WARNING} from "../misc/vars";
import {sort} from "ith-sort";
import {compare, compareDefault, compareNum} from "ith-compare";
import {InkButton} from "../extensions";

const filterOptions = [
	{key: 'name', text: 'Name', value: 'name'},
	{key: 'link', text: 'Link', value: 'link'},
	{key: 'id', text: 'ID', value: 'id'},
	{key: 'ceo', text: 'CEO', value: 'ceo'},
	{key: 'email', text: 'E-Mail', value: 'email'}
];

const sortOptions = [
	{key: 'asc', order: 'ascending', title: 'Aufsteigend'},
	{key: 'desc', order: 'descending', title: 'Absteigend'}
];

const _HouseOptions = (Component) => ({children, deleteButtonText, deleteButtonAction, activateButtonText, activateButtonAction, loading, ...props}) => (
	<Component iconButtonElement={<InkButton><Icon name={loading ? 'spinner' : 'ellipsis vertical'} loading={loading}/></InkButton>}
	          anchorOrigin={{horizontal: 'right', vertical: 'top'}}
	          targetOrigin={{horizontal: 'right', vertical: 'top'}}
	           {...props}
	>
		<MenuItem primaryText={deleteButtonText} onClick={() => console.error('FUFUFu')}/>
		<MenuItem primaryText={activateButtonText} onClick={() => console.error('FUFUFu')}/>
		{children}
	</Component>
);
const HouseOptions = _HouseOptions(IconMenu);
HouseOptions.propTypes = {
	deleteButtonText: PropTypes.string.isRequired,
	activateButtonText: PropTypes.string.isRequired,
	deleteButtonAction: PropTypes.func.isRequired,
	activateButtonAction: PropTypes.func.isRequired,
	loading: PropTypes.bool
};
HouseOptions.defaultProps = {
	loading: false
};

const fromStorage = () => {
	return JSON.parse(window.localStorage.getItem(LOC_HOUSE_LIST_OPTIONS)) || {filter: '', filterOptions: 'name', sort: 'asc', filterState: []};
};

class HouseList extends React.Component {
	state = {
		filter: fromStorage(),
		_filter: {
			filter: '',
			filterOption: filterOptions[0].key
		}
	};
	
	componentDidMount() {
		this.props.onLoad();
	}
	
	setLocaleState = (obj) => {
		this.setState(obj);
		this.setState(state => ({
			...state,
			filter: {
				...state.filter,
				...obj
			}
		}));
		// window.localStorage.setItem(LOC_HOUSE_LIST_OPTIONS, JSON.stringify(this.state));
	};
	
	
	setFilterOption = filterOption => this.setState(state => ({
		...state,
		_filter: {
			...state._filter,
			filterOption
		}
	}));
	setFilter = filter => this.setState(state => ({
		...state,
		_filter: {
			...state._filter,
			filter
		}
	}));
	setSort = sort => this.setLocaleState({sort});
	
	
	sorted = () => {
		const {sort: how} = this.state.filter;
		return sort(how)(h => h.name);
	};
	
	filtered = () => {
		const {filter, filterOption} = this.state._filter;
		if (filter.trim() === '') return compareDefault;
		switch (filterOption) {
			case 'id': return compareNum(filter)(h => h.house_id);
			case 'name': return compare(filter)(h => h.name);
			case 'link': return compare(filter)(h => h.link);
			case 'ceo': return compare(filter)(h => h.ceo);
			case 'email': return compare(filter)(h => h.email);
			default: return compareDefault;
		}
	};
	
	filterStateAllSelected = () => !this.state.filter.filterState || !this.state.filter.filterState.length || this.state.filter.filterState.length === 3;
	
	filterState = () => {
		const {filterState} = this.state.filter;
		if (this.filterStateAllSelected()) {
			return () => true;
		}
		return (house) =>
			(filterState.indexOf('deleted') > -1 && !!house.deleted_at) ? (true) : (
				Boolean(!house.deleted_at && ((filterState.indexOf('active') > -1 && house.active) || (filterState.indexOf('inactive') > -1 && !house.active)))
			);
	};
	
	
	filterStateMapper = (state) => {
		switch(state) {
			case 'inactive': return 'Inaktiv';
			case 'deleted': return 'Gelöscht';
			default: return 'Aktiv';
		}
	};
	
	filterStateSelection = () => {
		if ( this.filterStateAllSelected()) return 'Alle anzeigen';
		return this.state.filter.filterState.map(state => this.filterStateMapper(state)).join(', ');
	};
	
	subheader = () => {
		const {filter, filterOption} = this.state._filter;
		if ( !filter ) return 'Liste aller Autohäuser';
		switch (filterOption) {
			case 'id': return `Authäuser mit der ID <${filter}>`;
			case 'name': return `Authäuser mit dem Namen "${filter}"`;
			case 'link': return `Authäuser mit dem Link "${filter}"`;
			case 'ceo': return `Autohäuser von CEO: "${filter}"`;
			case 'email': return `Autohäuser mit E-Mail: "${filter}"`;
			default: return 'Liste aller Autohäuser *';
		}
	};
	
	handleFilterStateChange = (_, index, filterState) => this.setState(state => ({
		...state,
		filter: {
			...state.filter,
			filterState
		}
	}));
	
	// filtered = () => this.state.filter ? this.filter() : this.props.houses;
	
	render() {
		const {onSelect, onCreate, onDelete, isDeleting, isLoading, onRegenerate, isUpdating, onActivate, houses} = this.props;
		const {filterState = []} = this.state.filter;
		window.localStorage.setItem(LOC_HOUSE_LIST_OPTIONS, JSON.stringify(this.state.filter));
		if (isLoading) {
			return <Placeholder repeat={2}/>;
		}
		// const filteredSortedHouses = this.filtered().filter(this.filterState()).sort(this.sorted());
		const filteredSortedHouses = houses.filter(this.filterState()).filter(this.filtered()).sort(this.sorted());
		return (
			<div>
				<PageHeader align="space-between">
					<Subbar>
						<Title loading={isLoading} style={{
							marginLeft: 10
						}}>Autohäuser</Title>
					</Subbar>
					<Subbar>
						<Subbar>
							<Label>Anzeigen</Label>
							<SelectField
								underlineStyle={{display: 'none'}}
								multiple={true}
								selectionRenderer={this.filterStateSelection}
								value={filterState}
								onChange={this.handleFilterStateChange}>
								<MenuItem value={'active'} primaryText={'Aktiv'} insetChildren={true}
								          checked={filterState.indexOf('active') > -1}/>
								<MenuItem value={'inactive'} primaryText={'Inaktiv'} insetChildren={true}
								          checked={filterState.indexOf('inactive') > -1}/>
								<MenuItem value={'deleted'} primaryText={'Gelöscht'} insetChildren={true}
								          checked={filterState.indexOf('deleted') > -1}/>
							</SelectField>
						</Subbar>
						<Sortable value={this.state.filter.sort || 'asc'} onChange={(_, key, value) => this.setSort(value)} options={sortOptions}/>
						<SearchFilter
							value={this.state._filter.filter}
							onChange={value => this.setFilter(value)}
							selected={this.state._filter.filterOption}
							options={filterOptions}
							onSelect={value => this.setFilterOption(value)}
						/>
						<InkButton onClick={onCreate}><Icon name="plus" size="large"/></InkButton>
					</Subbar>
				</PageHeader>
				<List style={{marginTop: 15}}>
					<Subheader inset={true}>{this.subheader()}</Subheader>
					{filteredSortedHouses.map(house =>
						<ListItem
							leftIcon={house.deleted_at ? <DeleteIcon/> : (house.active ? <ActivateIcon color={COLOR_POSITIVE}/> : <DeactivateIcon color={COLOR_WARNING}/>)}
							disabled={isDeleting(house.house_id)}
							onClick={onSelect.bind(this, house)}
							key={`list-${house.house_id}`}
							primaryText={house.name}
							rightIconButton={
								/*onDelete &&
								<IconButton onClick={() => this.setState({confirm: onDelete.bind(this, house.house_id, () => this.setState({confirm: false}))})}>
									<Icon name={isDeleting(house.house_id) ? 'spinner' : 'trash'} loading={isDeleting(house.house_id)} size="large"/>
								</IconButton>*/
								<ExtensionMenu loading={isUpdating(house.house_id)}>
									<MenuItem disabled={true} primaryText={house.name}/>
									<Divider />
									<MenuItem
										leftIcon={house.deleted_at ? <UndeleteIcon/> : <DeleteIcon />}
										primaryText={house.deleted_at ? 'Wiederherstellen' : 'Löschen'}
										onClick={() => {
											if (house.deleted_at) {
												onRegenerate(house);
											} else {
												this.setState({
													confirm: onDelete.bind(this, house.house_id, () => this.setState({confirm: false}))
												});
											}
										}}/>
									<MenuItem
										leftIcon={house.active ? <DeactivateIcon/> : <ActivateIcon/>}
										primaryText={house.active ? 'Deaktivieren' : 'Aktivieren'}
										onClick={() => onActivate(house, !house.active)}/>
								</ExtensionMenu>
							}
							secondaryText={
								<Subbar align={Subbar.ALIGN_START} style={{display: 'flex'}}>
									<SubItem width={1/5}>{house.link}</SubItem>
									<SubItem width={1/5}>{house.ceo}</SubItem>
									<SubItem width={1/5}>{house.email}</SubItem>
									<SubItem width={1/5}>{house.timezone}</SubItem>
									<SubItem width={1/5}>€ {house.price_month}</SubItem>
								</Subbar>
							}
						/>
					)}
				</List>
				{/*<pre>{JSON.stringify(this.state, null, 4)}</pre>*/}
				<Confirm open={!!this.state.confirm} onCancel={() => this.setState({confirm: false})} onConfirm={() => this.state.confirm()} cancelButton="Nein" confirmButton="Ja" content="Wirklich löschen?"/>
			</div>
		);
	}
}

HouseList.propTypes = {
	houses: PropTypes.array.isRequired,
	onLoad: PropTypes.func,
	onSelect: PropTypes.func.isRequired,
	onCreate: PropTypes.func.isRequired,
	onDelete: PropTypes.func,
	isDeleting: PropTypes.func,
	isLoading: PropTypes.bool,
	onRegenerate: PropTypes.func.isRequired,
	isUpdating: PropTypes.func,
	onActivate: PropTypes.func.isRequired
};

HouseList.defaultProps = {
	houses: [],
	onLoad: () => {},
	isDeleting: (house_id) => false,
	isLoading: false,
	isUpdating: () => false,
	onSelect: house => { console.warn('HouseList: SHOULD set function "onSelect(house)"');},
	onCreate: () => { console.warn('HouseList: SHOULD set function "onCreate()"'); }
};

export default translate()(HouseList);


// WEBPACK FOOTER //
// ./src/components/HouseList.js